// Editable site content — replace placeholders with real details anytime.
export const SITE = {
  name: "Anubhav Sahni",
  handle: "@realtorsahni",
  instagram: "https://www.instagram.com/realtorsahni",
  youtube: "https://youtube.com/@realtorsahni",
  city: "India",
  // Canonical/OG base URL — adapts to the current deployment origin (preview, production, or custom domain).
  url: typeof window !== "undefined" && window.location ? window.location.origin : "",
  twitter: "@realtorsahni",
  // Digits only, with country code, no + or spaces — used for the WhatsApp link.
  whatsappNumber: "919999999999",
  phoneDisplay: "+91 99999 99999",
  phonePlaceholder: "+91 98765 43210",
  email: "info@anubhavsahni.com",
};

export const waLink = (msg = "Hi Anubhav, I'd like to know more.") =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(msg)}`;
